export default __webpack_public_path__ + "static/media/gigantier.1a7af128.svg";